import { truktApi } from '@api';
import { v1 as uuid } from 'uuid';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getErrorMessage } from '@trukt/portal-utils/getErrorMessage';
import { QUERY_CACHE_IDS_MAP } from '@types';
import { useProgressNotifierContext } from '@trukt/ui/ProgressNotifierContext';

import { UseDeleteReportMutationResult } from './useDeleteReportMutation.types';

export const useDeleteReportMutation = () => {
  const progressNotifierContext = useProgressNotifierContext();
  const queryClient = useQueryClient();

  const mutation: UseDeleteReportMutationResult = useMutation({
    mutationFn: ({ reportId }) => truktApi.report.delete(reportId),

    onMutate: () => {
      const progressNotifierId = uuid();
      progressNotifierContext.dispatchNotification({
        id: progressNotifierId,
        label: 'Deleting report.',
      });

      return { progressNotifierId };
    },

    onError: (error, _params, context) => {
      if (context?.progressNotifierId) {
        progressNotifierContext.updateNotification(context.progressNotifierId, {
          errorMessage: getErrorMessage(error),
          isError: true,
        });
      }
    },

    onSuccess: (_data, _params, context) => {
      if (context?.progressNotifierId) {
        progressNotifierContext.updateNotification(context.progressNotifierId, {
          isSuccess: true,
        });
      }

      queryClient.invalidateQueries({
        queryKey: [QUERY_CACHE_IDS_MAP.REPORTS],
      });
    },
  });

  return mutation;
};
